import { jsx } from "react/jsx-runtime";
import { Box, Loader } from "braid-design-system";
import clsx from "clsx";
import { Img } from "react-image";
import { StrategiesEnum } from "@seek/image-service-types";
import compact from "lodash/compact.js";
import isEmpty from "lodash/isEmpty.js";
import { loaderHeight, loading, fixedHeight, selectable } from "./Logo.css.mjs";
const getAssetSrcs = ({
  asset,
  strategyName
}) => {
  if (!asset || isEmpty(asset)) {
    return [];
  }
  const { url: baseUrl, strategies } = asset;
  return compact([
    strategies == null ? void 0 : strategies[strategyName],
    baseUrl && `${baseUrl}/${[strategyName]}`,
    baseUrl && `${baseUrl}/`
  ]);
};
const getLogoSrcs = (logo, placement) => {
  if (!logo || isEmpty(logo)) {
    return [];
  }
  const strategyName = {
    jdp: StrategiesEnum.JDP_LOGO,
    brandCard: StrategiesEnum.JDP_LOGO,
    serp: StrategiesEnum.SERP_LOGO,
    assetLibrary: StrategiesEnum.JDP_LOGO
  }[placement || "jdp"];
  return compact([
    // @ts-expect-error
    ...getAssetSrcs({ asset: logo, strategyName })
  ]);
};
const getRandomNumberByRange = (range) => Math.floor(Math.random() * range);
const BRANDING_GATEWAY_BASE_URL = "https://bx-branding-gateway.cloud.seek.com.au";
const getExperimentSerpLogoUrl = (brandId, placement) => {
  if (brandId.length === 0 || placement !== "serp" || getRandomNumberByRange(3) < 2) {
    return void 0;
  }
  return `${BRANDING_GATEWAY_BASE_URL}/${brandId}/serpLogo`;
};
const Logo = ({
  asset,
  selectable: selectable$1 = false,
  showLoading = false,
  directUrl,
  withPlaceholder,
  placement = "jdp",
  experimentBrandId = ""
}) => {
  const logoSrcs = getLogoSrcs(asset, placement);
  const src = getExperimentSerpLogoUrl(experimentBrandId, placement) || directUrl || logoSrcs;
  const background = withPlaceholder ? "neutralLight" : "surface";
  return /* @__PURE__ */ jsx(Box, { width: "full", height: "full", background, children: showLoading ? /* @__PURE__ */ jsx(
    Box,
    {
      display: "flex",
      flexDirection: "column",
      alignItems: withPlaceholder ? "center" : "flexStart",
      justifyContent: "center",
      className: [
        loaderHeight,
        withPlaceholder ? loading : void 0
      ],
      children: /* @__PURE__ */ jsx(
        Box,
        {
          display: "flex",
          justifyContent: withPlaceholder ? "center" : "flexStart",
          alignItems: "center",
          height: "full",
          children: /* @__PURE__ */ jsx(Loader, { size: "xsmall" })
        }
      )
    }
  ) : /* @__PURE__ */ jsx(Box, { display: "flex", "data-testid": "bx-logo-image", height: "full", children: /* @__PURE__ */ jsx(
    Img,
    {
      src,
      alt: "",
      className: clsx(fixedHeight, {
        [selectable]: selectable$1
      })
    }
  ) }) });
};
export {
  Logo,
  getAssetSrcs
};
